import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useColorPricingCategoryContext } from "../../../../contexts/color-pricing-category.context";
import ColorPricingCategoryService from "../../../../services/ColorPricingCategoryService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/colorPricingCategoryTableColumn.";

function ColorPricingCategoryTable() {
  const history = useHistory();

  const {
    state: { loading, ColorPricingCategory },
    getAllColorPricingCategory,
  } = useColorPricingCategoryContext();

  useEffect(() => {
    getAllColorPricingCategory();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => ColorPricingCategory, [ColorPricingCategory]);

  const removeColorPricingCategory = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
        debugger
      const result = await ColorPricingCategoryService.remove(id);
      if (result.success === true) {
        getAllColorPricingCategory();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Color Pricing Category</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/color-pricing-category/add")}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={loading}
        data={data || []}
        columns={columns}
        idField="cpC_ID"
        onEdit={(id) => history.push(`/masters/color-pricing-category/edit/${id}`)}
        onRemove={(id) => removeColorPricingCategory(id)}
      />
    </div>
  );
}

export default ColorPricingCategoryTable;

